import DSMobileFooter, { MobileFooterWithSchema } from './Footer.js';
import { DSMobileFooterText, DSMobileFooterTextWithSchema } from './Text.js';
import { DSMobileFooterAction, DSMobileFooterActionWithSchema } from './Action.js';

export {
  DSMobileFooterText,
  DSMobileFooterAction,
  DSMobileFooter,
  DSMobileFooterActionWithSchema,
  DSMobileFooterTextWithSchema,
  MobileFooterWithSchema,
};
